import "./QuickPrompts.css";

const suggestions = [

    "Remove Circled",

    "More realistic",

    "Change background",

    "Remove background",

];

const QuickPrompts = ({ editMessage, setEditMessage }) => {
    const safeMessage = editMessage || "";
    const activePrompts = suggestions.filter(s => safeMessage.includes(s));

    const handleSelect = (item) => {
        if (safeMessage.includes(item)) {
            // Remove it
            let newMsg = safeMessage.replace(item, "").trim();
            // Clean up dangling commas
            newMsg = newMsg.replace(/,\s*,/g, ',').replace(/^,\s*|,\s*$/g, '').trim();
            setEditMessage(newMsg);
        } else {
            // Add it if under limit
            if (activePrompts.length < 3) {
                const newMsg = safeMessage ? safeMessage + ', ' + item : item;
                setEditMessage(newMsg);
            }
        }
    };

    return (

        <div className="quick-prompts">

            {suggestions.map((item)=>(

                <button

                    key={item}

                    onClick={()=>handleSelect(item)}

                    className={safeMessage.includes(item) ? "active" : ""}

                    disabled={!safeMessage.includes(item) && activePrompts.length >= 3}

                >

                    {item}

                </button>

            ))}

        </div>

    );

};

export default QuickPrompts;